import { useTranslation } from 'next-i18next';
import { twMerge } from 'tailwind-merge';

import { newsSlugs } from '@boss/constants/corporate-jobs';
import { NewsArticleFields } from '@boss/types/corporate-jobs';
import { Button, NewsArticleCard } from '@boss/ui';

import { getNewsArticleProps } from '../../mappers/PropsMapping';

type HighlightedNewsProps = {
  highlightedNews: NewsArticleFields[];
  locale: string;
  textClassName?: string;
};
const HighlightedNews = ({ highlightedNews, locale, textClassName }: HighlightedNewsProps) => {
  const { t } = useTranslation(['news']);
  const buttonBorderClassName = textClassName === 'text-white' ? 'border-white' : undefined;

  return (
    <div className={twMerge('w-full', textClassName)}>
      <h2 className="mb-8">{t('newsTitle')}</h2>
      <div className="grid w-full grid-cols-1 gap-12 md:grid-cols-3">
        {highlightedNews?.map(article => (
          <NewsArticleCard
            key={article.id}
            translations={{
              buttonText: t('cardButton'),
            }}
            {...getNewsArticleProps(article, locale)}
          />
        ))}
      </div>
      <div className="mt-8 flex w-full items-center justify-center">
        <Button
          className={buttonBorderClassName}
          href={newsSlugs[locale]}
          label={t('more')}
          labelClassName={textClassName}
          type="secondary"
        />
      </div>
    </div>
  );
};

export default HighlightedNews;
